// extracted by mini-css-extract-plugin
export default {"container":"S02_container__BIcI2","wrapper":"S02_wrapper__kJXeH","left":"S02_left__kZ7vG","bg01":"S02_bg01__v8G+F","bg02":"S02_bg02__gFrGX","right":"S02_right__zo01Y"};